import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { useTeamConfig } from "./useTeamConfig";

const useDisabledRoutesHandlers = () => {
  const router = useRouter();
  const teamConfig = useTeamConfig();
  const { teamSchema, defaultRoute } = teamConfig;
  const disabledRoutes = teamConfig.disabledRoutes as string[];
  const [isLoading, setIsLoading] = React.useState(true);

  const handleRedirectToDefault = async () => {
    const currentPath = router.pathname;
    if (disabledRoutes.includes(currentPath)) {
      await router.push({
        pathname: defaultRoute,
        query: {
          teamSchema,
        },
      });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    handleRedirectToDefault();
  }, []);

  return { isLoading };
};

export default useDisabledRoutesHandlers;
